














































import Vue, {VueConstructor} from "vue";
import {ValidationObserver} from "vee-validate";
import CustomContainer from "@/components/layouts/CustomContainer.vue";

  export default (Vue as VueConstructor<
      Vue & {
        $refs: {
          obs: InstanceType<typeof ValidationObserver>;
        };
      }
      >).extend({
    data() {
      return {
        errorSnackbar: false,
        errorFields: []
      }
    },
    components: {
      CustomContainer,
      ValidationObserver,
    },
    props: {
      title: {
        type: String,
        required: true
      },
      disabled: {
        type: Boolean,
        default: () => {
          return false
        }
      }
    },
    methods: {
      handleCancel: function () {
        this.$router.back()
      },
      save: async function () {
        const isValid = await this.$refs.obs.validate()
        this.$emit('save:form', isValid)
        if (!isValid) {
          const errors = Object.keys(this.$refs.obs.errors)
          this.errorFields = errors.filter(field => {
            return this.$refs.obs.errors[field].length >= 1
          })
          this.errorSnackbar = true
        }
      }
    }
  })
